import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventService } from '../../../../../core/services/event.service';

@Component({
    selector: 'open-pictures-modal',
    templateUrl: 'open-pictures.modal.html',
    styleUrls: ['open-pictures.modal.scss'],
    standalone: false
})

export class OpenPictureModalComponent {
  pictures: any;
  index: number;
  constructor(public dialogRef: MatDialogRef<OpenPictureModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data,  public eventService: EventService) {
    if (data) {
      this.pictures = data.pictures;
      this.index = data.index;
    }
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  next() {
    if (this.index <= this.pictures.length - 1) {
      this.index++;
    }
  }

  previous() {
    if (this.index !== 0) {
      this.index--;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
